<template>
  <!--url da inspiração: -->
  <div class="main">
    
    <router-view/>
  </div>
</template>

<style scoped>
.main{
  background-color: #ffffff;
  position: absolute;
  z-index: -2;
  width: 98.7vw;
  min-height: 100vh;
}


</style>